import { Button, Divider, Form, Input, Popconfirm, Select, Space, Spin, Tabs, Typography } from "antd";
import moment from "moment";
import React, { FC, useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import MainLayout from "../../components/main-layout/main-layout";
import Notification from "../../components/notification/notification";
import { getOverViewCalculateByPeriod, getPeriodsOnly, logout, resetPeriod, updateAnnouncePeriod } from "../../services/services";
import { utils } from "../../services/utils";
import { PeriodType } from "../../types/period.type";
import './announce.css';
import { LottoPermission } from "../member/member.type";

const { Title, Text, Paragraph } = Typography;

const Announce: FC = () => {
    let history = useHistory();
    const [loading, setLoading] = useState(true);
    const [periods, setPeriods] = useState<any>(null);
    const [periodSelected, setPeriodSelected] = useState<PeriodType | null>(null);
    const [result, setResult] = useState<any>(null);
    const [form] = Form.useForm();
    const { role, permissions } = utils.getRoleAndPermissions();

    const getPeriods = useCallback(async () => {
        const date = new Date();

        let filter = `?filter=dateOpen||$eq||${moment().format('YYYY-MM-DD 00:05:00')}`;
        if (role === 'header') {
            if (permissions !== 'null') {
                const lottoMasterIds = JSON.parse(permissions).map((v: LottoPermission) => {
                    return v.lottoMaster?.id
                });
                filter += '&filter=lottoMaster.id||$in||' + lottoMasterIds.join(",")
            }
        }
        filter += '&sort=id,DESC';

        const response = await getPeriodsOnly(filter);
        setPeriods(response.data.data);
    }, []);

    useEffect(() => {
        getPeriods().then(() => setLoading(false)).catch(() => {
            setLoading(false);
            logout();
            return history.push('/login');
        });
    }, [getPeriods])

    const refreshPeriod = async (periodId: any) => {
        setLoading(true);
        try {
            const response = await getOverViewCalculateByPeriod(parseInt(periodId));
            setResult(response.data);

        } catch (error) {
            Notification('error', 'เกิดข้อผิดพลาด ' + error)
        }
        setLoading(false);
    }

    const onChangePeriod = async (e: any) => {
        const period: PeriodType = periods.find((v: PeriodType) => v.id === parseInt(e));

        if (period.lottoMaster.isOneAnnounce === "true") {
            form.setFieldsValue({
                up6: period.up3,
                down6: period.down2
            });
        } else {
            form.setFieldsValue({
                up6: period.up6,
                down6: period.down6
            });
        }

        setPeriodSelected(period);
        await refreshPeriod(e);
    }

    const convertToPeriodName = (v: PeriodType) => {
        const createdDate = moment(v.dateAnnounce).add(543, 'year').toDate();
        const periodDate = moment(createdDate).format('วันที่ DD MMMM YYYY');
        const name = "หวย" + v.lottoMaster?.name + " (" + periodDate + ")";
        return name;
    }

    const renderBet = (type: string) => {
        if (!result) return <></>;
        const data = type === 'up' ? result.up.data : result.down.data;
        const rows = [...Array(Math.ceil(data.length / 5))];
        const dataDownRows = rows.map((row, idx) => data.slice(idx * 5, idx * 5 + 5));
        return dataDownRows.map((row, index) => {

            return (
                <tr key={index} className="text-center">
                    <td style={{ width: '5%' }}><span style={{ color: '#108ee9' }}>{row[0].numbers}</span></td>
                    <td style={{ width: '10%' }} className="text-right"><span style={{ color: '#c41d7f' }}>{utils.numberWithCommas(row[0].pay)}</span></td>
                    <td style={{ width: '5%' }}><span style={{ color: '#389e0d' }}>{row[0].winAmount}</span></td>
                    <td style={{ width: '5%' }}><span style={{ color: '#108ee9' }}>{row[1].numbers}</span></td>
                    <td style={{ width: '10%' }} className="text-right"><span style={{ color: '#c41d7f' }}>{utils.numberWithCommas(row[1].pay)}</span></td>
                    <td style={{ width: '5%' }}><span style={{ color: '#389e0d' }}>{row[1].winAmount}</span></td>
                    <td style={{ width: '5%' }}><span style={{ color: '#108ee9' }}>{row[2].numbers}</span></td>
                    <td style={{ width: '10%' }} className="text-right"><span style={{ color: '#c41d7f' }}>{utils.numberWithCommas(row[2].pay)}</span></td>
                    <td style={{ width: '5%' }}><span style={{ color: '#389e0d' }}>{row[2].winAmount}</span></td>
                    <td style={{ width: '5%' }}><span style={{ color: '#108ee9' }}>{row[3].numbers}</span></td>
                    <td style={{ width: '10%' }} className="text-right"><span style={{ color: '#c41d7f' }}>{utils.numberWithCommas(row[3].pay)}</span></td>
                    <td style={{ width: '5%' }}><span style={{ color: '#389e0d' }}>{row[3].winAmount}</span></td>
                    <td style={{ width: '5%' }}><span style={{ color: '#108ee9' }}>{row[4].numbers}</span></td>
                    <td style={{ width: '10%' }} className="text-right"><span style={{ color: '#c41d7f' }}>{utils.numberWithCommas(row[4].pay)}</span></td>
                    <td style={{ width: '5%' }}><span style={{ color: '#389e0d' }}>{row[4].winAmount}</span></td>
                </tr>
            );
        });
    }

    const save = async (values: any) => {
        setLoading(true);

        if (!periodSelected) return;

        try {

            let body = {
                up6: '',
                up3: '',
                up2: '',
                down6: '',
                down2: ''
            };

            if (periodSelected.lottoMaster.isOneAnnounce === 'true') {
                body = {
                    up6: values.down6 + values.up6,
                    up3: values.up6,
                    up2: values.up6.substring(1, values.up6.length),
                    down6: values.down6,
                    down2: values.down6
                }
            } else {

                // 6 - 3 = 3, 5 - 3 = 2
                body = {
                    up6: values.up6,
                    up3: values.up6.substring(periodSelected.lottoMaster.amountAnnounceUp - 3, values.up6.length),
                    up2: values.up6.substring(periodSelected.lottoMaster.amountAnnounceUp - 2, values.up6.length),
                    down6: values.down6,
                    down2: values.down6.substring(periodSelected.lottoMaster.amountAnnounceDown - 2, values.down6.length)
                };
            }

            const response = await updateAnnouncePeriod(periodSelected.id, body);
            if (response.status === 200) {
                Notification('success', 'บันทึกข้อมูลเรียบร้อย');
            } else {
                throw new Error('กรุณาลองใหม่อีกครั้ง');
            }

        } catch (error) {
            Notification('error', 'เกิดข้อผิดพลาด ' + error);
        }
        setLoading(false);
    }

    const resetAnnouncePeriod = async () => {
        if (!periodSelected) return;
        try {
            const response = await resetPeriod(periodSelected.id);
            if (response.status === 200) {
                if (periodSelected.lottoMaster.isOneAnnounce === "true") {
                    form.setFieldsValue({
                        up3: null,
                        down2: null
                    });
                } else {
                    form.setFieldsValue({
                        up6: null,
                        down6: null
                    });
                }
                Notification('success', 'เริ่มใหม่เรียบร้อยแล้ว');
            } else {
                throw new Error('กรุณาลองใหม่อีกครั้ง');
            }
        } catch (error) {
            Notification('error', 'เกิดข้อผิดพลาด ' + error);
        }
    }

    const permissionsPeriods = () => {


        if (role === 'header') {
            if (permissions === 'null') {
                return <Select
                    placeholder="ไม่มีสิทธิ์ออกผล"
                    style={{ width: '350px' }}
                ></Select>
            }
        }

        return (
            <Select
                placeholder="เลือกงวด"
                style={{ width: '350px' }}
                onChange={(e) => onChangePeriod(e)}
            >
                {periods ? periods.map((v: PeriodType) => <Select.Option key={v.id}>{convertToPeriodName(v)}</Select.Option>) : <></>}
            </Select>
        )
    }

    return (
        <Spin spinning={loading}>
            <MainLayout menu="announce">
                <Typography style={{ fontSize: 16 }}>
                    <Title level={4}>ออกผลรางวัล</Title>
                    <Space>
                        {permissionsPeriods()}
                    </Space>
                    <Divider className="divider-inside" />
                    {result ? <>
                        <Title level={5}>{periodSelected ? convertToPeriodName(periodSelected) : ''}</Title>
                        {periodSelected ?
                            <Form layout="inline" form={form} onFinish={save}>
                                <Form.Item
                                    label="เลขบน"
                                    name={"up6"}
                                    rules={[{ required: true, message: 'ระบุสำหรับออกผลเลขบน' }, {
                                        pattern: /^(?:\d*)$/,
                                        message: "กรุณาระบุเพียงตัวเลข",
                                    }]}
                                >
                                    <Input maxLength={periodSelected.lottoMaster.amountAnnounceUp} placeholder={`เลขบน ${periodSelected.lottoMaster.amountAnnounceUp} ตัว`} />
                                </Form.Item>
                                <Form.Item
                                    label="เลขล่าง"
                                    name={"down6"}
                                    rules={[{ required: true, message: 'ระบุสำหรับออกผลเลขล่าง' }, {
                                        pattern: /^(?:\d*)$/,
                                        message: "กรุณาระบุเพียงตัวเลข",
                                    }]}
                                >
                                    <Input maxLength={periodSelected.lottoMaster.amountAnnounceDown} placeholder={`เลขล่าง ${periodSelected.lottoMaster.amountAnnounceDown} ตัว`} />
                                </Form.Item>
                                <Form.Item >
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                    >
                                        ออกผล
                                    </Button>
                                </Form.Item>
                                {periodSelected ?
                                    <Form.Item >
                                        <Popconfirm placement="topLeft" title={'ต้องการเริ่มออกผลใหม่ใช่หรือไม่'} onConfirm={resetAnnouncePeriod} okText="ใช่" cancelText="ไม่ใช่">
                                            <Button
                                                type="default"
                                                htmlType="button"
                                            >
                                                เริ่มใหม่
                                            </Button>
                                        </Popconfirm>
                                    </Form.Item> : <></>}
                                {periodSelected ?
                                    <Form.Item >
                                        <Button
                                            type="default"
                                            htmlType="button"
                                            onClick={() => refreshPeriod(periodSelected.id)}
                                        >
                                            Refresh
                                        </Button>
                                    </Form.Item> : <></>}
                            </Form>
                            : <></>}
                        <Divider className="divider-inside" />
                    </> : <></>}
                    <Tabs defaultActiveKey="1">
                        <Tabs.TabPane tab="เลขบน" key={1}>
                            {result ?
                                <div>
                                    <table className="announce">
                                        <thead>
                                            <tr className="text-center">
                                                <th style={{ backgroundColor: '#2db7f5', color: 'white' }}>เลข</th>
                                                <th style={{ backgroundColor: '#d4380d', color: 'white' }} className="text-right">จ่าย</th>
                                                <th style={{ backgroundColor: '#389e0d', color: 'white' }} className="text-right">ถูก (คน)</th>
                                                <th style={{ backgroundColor: '#2db7f5', color: 'white' }}>เลข</th>
                                                <th style={{ backgroundColor: '#d4380d', color: 'white' }} className="text-right">จ่าย</th>
                                                <th style={{ backgroundColor: '#389e0d', color: 'white' }} className="text-right">ถูก (คน)</th>
                                                <th style={{ backgroundColor: '#2db7f5', color: 'white' }}>เลข</th>
                                                <th style={{ backgroundColor: '#d4380d', color: 'white' }} className="text-right">จ่าย</th>
                                                <th style={{ backgroundColor: '#389e0d', color: 'white' }} className="text-right">ถูก (คน)</th>
                                                <th style={{ backgroundColor: '#2db7f5', color: 'white' }}>เลข</th>
                                                <th style={{ backgroundColor: '#d4380d', color: 'white' }} className="text-right">จ่าย</th>
                                                <th style={{ backgroundColor: '#389e0d', color: 'white' }} className="text-right">ถูก (คน)</th>
                                                <th style={{ backgroundColor: '#2db7f5', color: 'white' }}>เลข</th>
                                                <th style={{ backgroundColor: '#d4380d', color: 'white' }} className="text-right">จ่าย</th>
                                                <th style={{ backgroundColor: '#389e0d', color: 'white' }} className="text-right">ถูก (คน)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {renderBet('up')}
                                        </tbody>
                                    </table>
                                </div> : <></>}
                        </Tabs.TabPane>
                        <Tabs.TabPane tab={'เลขล่าง'} key={2}>
                            {result ?
                                <div>
                                    <table className="announce">
                                        <thead>
                                            <tr className="text-center">
                                                <th style={{ backgroundColor: '#2db7f5', color: 'white' }}>เลข</th>
                                                <th style={{ backgroundColor: '#d4380d', color: 'white' }} className="text-right">จ่าย</th>
                                                <th style={{ backgroundColor: '#389e0d', color: 'white' }} className="text-right">ถูก (คน)</th>
                                                <th style={{ backgroundColor: '#2db7f5', color: 'white' }}>เลข</th>
                                                <th style={{ backgroundColor: '#d4380d', color: 'white' }} className="text-right">จ่าย</th>
                                                <th style={{ backgroundColor: '#389e0d', color: 'white' }} className="text-right">ถูก (คน)</th>
                                                <th style={{ backgroundColor: '#2db7f5', color: 'white' }}>เลข</th>
                                                <th style={{ backgroundColor: '#d4380d', color: 'white' }} className="text-right">จ่าย</th>
                                                <th style={{ backgroundColor: '#389e0d', color: 'white' }} className="text-right">ถูก (คน)</th>
                                                <th style={{ backgroundColor: '#2db7f5', color: 'white' }}>เลข</th>
                                                <th style={{ backgroundColor: '#d4380d', color: 'white' }} className="text-right">จ่าย</th>
                                                <th style={{ backgroundColor: '#389e0d', color: 'white' }} className="text-right">ถูก (คน)</th>
                                                <th style={{ backgroundColor: '#2db7f5', color: 'white' }}>เลข</th>
                                                <th style={{ backgroundColor: '#d4380d', color: 'white' }} className="text-right">จ่าย</th>
                                                <th style={{ backgroundColor: '#389e0d', color: 'white' }} className="text-right">ถูก (คน)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {renderBet('down')}
                                        </tbody>
                                    </table>
                                </div> : <></>}
                        </Tabs.TabPane>
                    </Tabs>
                </Typography>
            </MainLayout>
        </Spin >
    );
}

export default Announce;